<template>
    <div v-if="client">
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sms Provider</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.mpesaSettings.smsProvider" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sms Text</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.mpesaSettings.smsText" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <p class="title is-5">Phone Number Validation</p>

        <div class="field is-horizontal">
            <div class="field-label is-horizontal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.mpesaSettings.phoneNumberValidationEnabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Confirmation attempts per hour</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.mpesaSettings.phoneNumberConfirmationAttempts" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Request Activity Expiration Seconds</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.mpesaSettings.phoneNumberActivityExpirationSeconds" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Code Expiration Seconds</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.mpesaSettings.phoneNumberCodeExpirationSeconds" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Expiration Days</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.mpesaSettings.phoneNumberExpirationDays" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label">
            </div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import clientService from "../../../../services/client.service";
    import utils from "../../../../utils";
    import state from "../../../../state";

    export default {
        name: "client-settings-mpesa",
        data: () => ({ client: null }),
        computed: {
            clientId: function() {
                return Number(this.$route.params.clientId);
            }
        },
        watch: {
            clientId: function() {
                this.loadClient();
            }
        },
        async mounted() {
            await clientService.ensure();
            this.loadClient();
        },
        methods: {
            loadClient() {
                this.client = utils.clone(state.clients.getClient(this.clientId));
            },
            async save() {
                await clientService.save(this.client);
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/settings/mpesa.vue